import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Form, Button, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import Message from '../components/Messages'
import Loader from '../components/Loader'
import FormContainer from '../components/FormContainer'
import { register } from '../actions/userActions'
import { useTranslation } from 'react-i18next';
import { variant_main } from '../constants/generalConstants'


const RegisterScreen = ({ location, history }) => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState(null)

  const dispatch = useDispatch()

  const userRegister = useSelector((state) => state.userRegister)
  const { loading, error, userInfo } = userRegister

  const redirect = location.search ? location.search.split('=')[1] : '/'

  useEffect(() => {
    if (userInfo) {
      history.push(redirect)
    }
  }, [history, userInfo, redirect])


  const submitHandler = (e) => {
    e.preventDefault()
    if (password !== confirmPassword) {
      setMessage('Passwords do not match')
    } else {
      dispatch(register(name, email, password))
    }
  }

  const { t } = useTranslation();

  return (
    <FormContainer>
      <h1 className=" dir-ltr display-3 fw-bold mb-3 text-capitalize main-color stroke">Sign Up</h1>
      {message && <Message variant='danger'>{message}</Message>}
      {error && <Message variant='danger'>{error}</Message>}
      {loading && <Loader />}
      <Form onSubmit={submitHandler}>
        <Form.Group controlId='name'>
          <Form.Label>{t('Name')}</Form.Label>
          <Form.Control
            type='text'
            placeholder={t('Enter Name')}
            value={name}
            onChange={(e) => setName(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId='email'>
          <Form.Label>{t('Email Address')}</Form.Label>
          <Form.Control
            type='email'
            placeholder={t('Enter email')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId='password'>
          <Form.Label>{t('Password')}</Form.Label>
          <Form.Control
            type='password'
            placeholder={t('Enter password')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId='confirmPassword'>
          <Form.Label>{t('Confirm Password')}</Form.Label>
          <Form.Control
            type='password'
            placeholder={t('Confirm password')}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Button type='submit' variant={variant_main}>
          {t('Register')}
        </Button>
      </Form>

      <Row className='py-3'>
        <Col>
          {t('Have an Account')}?{' '}
          <Link to={redirect ? `/login?redirect=${redirect}` : '/login'}>
            {t('Login')}
          </Link>
        </Col>
      </Row>
    </FormContainer>
  )
}

export default RegisterScreen
